import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import PlanForm from './PlansForm';
import { updatePlan, viewPlan } from '../../Services/Utils/PlanApis';
import { notifySet } from '../../Services/Actions/CommonActions';

function EditPlan() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [serviceProviders, setServiceProviders] = useState([]);
  useEffect(() => {
    viewPlan({ id: params.id }).then((res) => {
      dispatch(change('planForm', 'name', res.view.name));
      const data = [];
      res.view.serviceProviderViews.map((item) => {
        data.push({
          id: item.id,
          name: item.name
        });
      });
      setServiceProviders(data);
    });
  }, []);

  const onButtonClick = (formData) => {
    const data = {
      name: formData.name,
      id: params.id,
      serviceProviderViews: serviceProviders
    };
    updatePlan(data).then((res) => {
      const { hasError, message } = res;
      if (hasError === false) {
        navigate('/plans');
        dispatch(notifySet({ type: 'success', message }));
      } else if (hasError === true) {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };
  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/plans">Plans</Link>
          <Link to="#">Edit Plan</Link>
        </Breadcrumbs>
      </div>
      <div className="row">
        <PlanForm
          buttonSaveText="Save"
          onButtonClick={onButtonClick}
          planText="Edit Plan"
          serviceProviders={serviceProviders}
          setServiceProviders={setServiceProviders}
        />
      </div>
    </div>
  );
}

export default EditPlan;
